import {
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { ReactElement } from "react";
import Samples from "./Samples";
import SearchIcon from "@mui/icons-material/Search";
import { useRef, useState } from "react";
import { getCBResults } from "../../../../api/llm";
import { LLMCBResponse } from "../../../../types/llm";
import Results from "./Results";
import Disclaimer from "../Disclaimer";
import TaskInfo from "../TaskInfo";
import PredictingOverlay from "../PredictingOverlay";

interface CBProps {
  index: number;
  tabValue: number;
}

const CB = (props: CBProps): ReactElement => {
  const { tabValue, index } = props;
  const [inputPremise, setInputPremise] = useState("");
  const [inputHypothesis, setInputHypothesis] = useState("");
  const [results, setResults] = useState<LLMCBResponse | undefined>(
    undefined,
  );
  const [isPredicting, setIsPredicting] = useState(false);
  const isPredictingRef = useRef(false);

  const handleSampleSelected = (premise: string, hypothesis: string) => {
    setInputPremise(premise);
    setInputHypothesis(hypothesis);
  };

  const handleInputSampleClick = () => {
    if (isPredictingRef.current) {
      return;
    }

    isPredictingRef.current = true;
    setIsPredicting(true);
    getCBResults(inputPremise, inputHypothesis)
      .then((response) => {
        console.log(response);
        setResults(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        isPredictingRef.current = false;
        setIsPredicting(false);
      });
  };

  return tabValue === index ? (
    <Container sx={{ marginTop: 5 }} hidden={tabValue !== index}>
      <Disclaimer />
      <TaskInfo
        name="CB"
        meaning="CommitmentBank"
        description="CB evaluates textual entailment in naturally occurring discourse. Given a premise and a hypothesis, the model classifies their relationship as entailment, contradiction, or neutral."
      />
      <Grid container spacing={2} columns={10}>
        <Grid item xs={10} md={6}>
          <Paper
            elevation={2}
            sx={{
              padding: 3,
              border: "1px solid",
              borderColor: "divider",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <PredictingOverlay open={isPredicting} />
            <Stack spacing={2.5}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={5}
                label="Premise"
                placeholder="Write the premise"
                id="input-cb-premise-text"
                value={inputPremise}
                onChange={(e) => setInputPremise(e.target.value)}
              />
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={5}
                label="Hypothesis"
                placeholder="Write the hypothesis"
                id="input-cb-hypothesis-text"
                value={inputHypothesis}
                onChange={(e) => setInputHypothesis(e.target.value)}
              />
              <Button
                variant="contained"
                size="large"
                fullWidth
                startIcon={<SearchIcon />}
                disabled={isPredicting}
                onClick={() => handleInputSampleClick()}
              >
                Analyze entailment
              </Button>
            </Stack>
          </Paper>
          <Container sx={{ marginTop: 2 }}>
            <Results results={results} />
          </Container>
        </Grid>
        <Grid item xs={10} md={4}>
          <Stack spacing={1.5}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Examples
            </Typography>
            <Samples sampleSelectedCallback={handleSampleSelected}></Samples>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  ) : (
    <></>
  );
};

export default CB;
